import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterEmissaoRendaFixaGarantiasTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }


    const updateRow = async (newRow) => {
        const {
            ID, RendaFixaCaracteristicasID, TipoLastro, ContaVinculada,
            CotasInferiores, AlienacaoFiduciaria, CessaoFiduciaria, FiancaBancaria, Hipoteca, 
            Penhor, Avalista, Fianca, FundoObra, FundoReserva, FundoLiquidez, Seguro, 
            Sobregarantia, PatrimonioSeparado
        } = newRow

        const body = {
            "RendaFixaCaracteristicasID": RendaFixaCaracteristicasID,
            "TipoLastro": TipoLastro,
            "ContaVinculada": ContaVinculada,
            "CotasInferiores": CotasInferiores,
            "AlienacaoFiduciaria": AlienacaoFiduciaria,
            "CessaoFiduciaria": CessaoFiduciaria,
            "FiancaBancaria": FiancaBancaria,
            "Hipoteca": Hipoteca,
            "Penhor": Penhor,
            "Avalista": Avalista,
            "Fianca": Fianca,
            "FundoObra": FundoObra,
            "FundoReserva": FundoReserva,
            "FundoLiquidez": FundoLiquidez,
            "Seguro": Seguro,
            "Sobregarantia": Sobregarantia,
            "PatrimonioSeparado": PatrimonioSeparado
        }

        props.loading(true)
        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'RendaFixaCaracteristicasID',
            headerName: 'RendaFixaCaracteristicasID',
            flex: 1,
            minWidth: 200,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'TipoLastro',
            headerName: 'TipoLastro',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'ContaVinculada',
            headerName: 'ContaVinculada',
            flex: 1,
            minWidth: 150,
            typeComponent: 'number',
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CotasInferiores',
            headerName: 'CotasInferiores',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'AlienacaoFiduciaria',
            headerName: 'AlienacaoFiduciaria',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CessaoFiduciaria',
            headerName: 'CessaoFiduciaria',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FiancaBancaria',
            headerName: 'FiancaBancaria',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Hipoteca',
            headerName: 'Hipoteca',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Penhor',
            headerName: 'Penhor',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Avalista',
            headerName: 'Avalista',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Fianca',
            headerName: 'Fianca',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FundoObra',
            headerName: 'FundoObra',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FundoReserva',
            headerName: 'FundoReserva',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'FundoLiquidez',
            headerName: 'FundoLiquidez',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Seguro',
            headerName: 'Seguro',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'Sobregarantia',
            headerName: 'Sobregarantia',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'PatrimonioSeparado',
            headerName: 'PatrimonioSeparado',
            flex: 1,
            minWidth: 150,
            disableColumnMenu: true,
            editable: true
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true}
                useDeleteButton={false} 
                />
        </div>
    )
}

ParameterEmissaoRendaFixaGarantiasTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterEmissaoRendaFixaGarantiasTable